import { render, staticRenderFns } from "./incident-sheet.component.vue?vue&type=template&id=6f140de7&scoped=true"
import script from "./incident-sheet.component.vue?vue&type=script&lang=js"
export * from "./incident-sheet.component.vue?vue&type=script&lang=js"
import style0 from "./incident-sheet.component.vue?vue&type=style&index=0&id=6f140de7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f140de7",
  null
  
)

export default component.exports